import $axios from '~/plugins/axios';

import { Api, CampaignLight, GetCampaignParams, PaginatorResult } from '~/api';
import { buildModule, createPaginationModule } from '../utils';
import { Dict, createDict, fetchAllPages } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withSubmodules({
		pagination: createPaginationModule({
			pageQueryKey: 'campaignsPage',
			pageSizeQueryKey: 'campaignsPerPage',
			itemCountGetter: 'campaigns/list/totalCount',
		}),
	})
	.withState({
		storedCampaigns: {} as Dict<CampaignLight>,
		campaigns: [] as CampaignLight[],
		loading: false,
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		byId: state => (campaignId: number): CampaignLight | null => (
			state.storedCampaigns[campaignId] ?? null
		),
		page: state => state.campaigns,
		loading: state => state.loading,
		totalCount: state => state.paginator?.totalCount ?? 0,
		storedCampaings: state => state.storedCampaigns,
	})
	.withMutations({
		SET_STORED_CAMPAIGNS (state, campaigns: CampaignLight[]) {
			state.storedCampaigns = {
				...state.storedCampaigns,
				...createDict(campaigns, (campaign) => campaign.id),
			};
		},
		SET_CAMPAIGNS (state, campaignIds: number[]) {
			state.campaigns = campaignIds.map(id => state.storedCampaigns[id]);
		},
		SET_LOADING (state, loading: boolean) {
			state.loading = loading;
		},
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	})
	.withActions({
		async get ({ commit }, params: GetCampaignParams = {}) {
			commit('SET_LOADING', true);
			const { data } = await api.get('/campaign', { params });
			commit('SET_LOADING', false);

			const campaigns = data.payload;
			const campaignIds = campaigns.map(campaign => campaign.id);

			commit('SET_STORED_CAMPAIGNS', campaigns);
			commit('SET_CAMPAIGNS', campaignIds);
			commit('SET_PAGINATOR', data.paginator);
		},
		async getAll ({ commit }, params: GetCampaignParams = {}) {
			commit('SET_LOADING', true);
			const data = await fetchAllPages('/campaign', params)<CampaignLight>(api);
			commit('SET_LOADING', false);
			commit('SET_STORED_CAMPAIGNS', data);
			commit('SET_CAMPAIGNS', data.map(campaign => campaign.id));
		},
	});
